/* Defines the report entity */
export interface IReport {
    TypeGroupCode: string;
    Name: string;
    Description: string;
    PathUrl: string;
    LstReport:any;
}
export class IReportView {
    TypeGroupCode: string;
    Name: string;
    Description: string;
    PathUrl: string;
    LstReport:any;
}
export interface IValidValue {
    Label: string;
    Value: string;
}

export class IReportViewer {
    Name: string;
    ParameterTypeName: string;
    Nullable: boolean;
    NullableSpecified: boolean;
    AllowBlank: boolean;
    AllowBlankSpecified: boolean;
    MultiValue: boolean;
    MultiValueSpecified: boolean;
    QueryParameter: boolean;
    QueryParameterSpecified: boolean;
    Prompt: string;
    PromptUser: boolean;
    PromptUserSpecified: boolean;
    Dependencies: string[];
    ValidValuesQueryBased: boolean;
    ValidValuesQueryBasedSpecified: boolean;
    ValidValues: IValidValue[];
    DefaultValuesQueryBased: boolean;
    DefaultValuesQueryBasedSpecified: boolean;
    DefaultValues: string[];
    ParameterStateName: string;
    ErrorMessage: any;
    DealerHierarchyId:number;
    UserId:any;

    ReportPath: string;
    ReportName: string;
    EmailDesc: string;
    EmailSubject: string;
    EmailTO: string;
    EmailCC: string;
    EmailBCC: string;
    EmailComment: string;
    EmailExportType: string;
    EmailEventType: string;

    ScheduleList: string[];
    ScheduleType: string;
    Interval: string;
    Parameters: string;
    MatchData: string;
    SId: string;
    SchDefinition:any;
 
}

export interface ISubScribeReport {
    ScheduleType: string;
    Interval: string;
    Hour: string;
    Mins: string;
    Format:string;
    ScheduleList: string[];
}

export interface IFilter {
    fcnPeriod: string;
    fcnFromDate: Date;
    fcnEndDate: Date;
    fcnMake: string;
    fcnModel: string;
}
export class Subscription{
    subscription_id:number;
    subscription_text:string;
    subscription_icon:string;
    css_name:string;
    subscription_time:string;
    is_deleted:boolean;
}

export class UserReportView{
    UserName : string;
    ReportURL : string[];
}

export class weeklyGroup {
    label: string;
    value: string;
}

export interface SSO{
    Uid: string
    Pwd: string
}